import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../FaIcon';

/**
 * La pastilla del rol de un usuario de la agencia (Administrador / Regular / Cliente).
 *
 * Vivía adentro de `AgencyTeam` como método de instancia; se extrajo cuando el Panel del cliente
 * empezó a listar al equipo (card abUohYUd). Las keys se quedan en `agency_team.*` a propósito: el
 * nombre de un rol es UN concepto del producto, y duplicarlo bajo otro namespace es la forma de que
 * dos pantallas terminen llamando distinto a la misma cosa.
 *
 * Un `userType` que no conocemos NO dibuja nada: inventarle una pastilla gris a un rol nuevo lo
 * haría pasar por uno de los tres de siempre.
 */
const ROLE_DEFS = {
    Admin: {modifier: 'admin', icon: 'user-shield', labelKey: 'agency_team.role_admin'},
    Regular: {modifier: 'regular', icon: 'user', labelKey: 'agency_team.role_regular'},
    Client: {modifier: 'client', icon: 'building', labelKey: 'agency_team.client_badge'},
};

export function RolePill({userType}) {
    const {t} = useTranslation();
    const role = ROLE_DEFS[userType];
    if (!role) return null;

    return (
        <span className={`role-pill -${role.modifier}`}>
            <FaIcon iconName={role.icon}/>{t(role.labelKey)}
        </span>
    );
}
